import React from 'react';

function ContactMe() {
    return (
        <section className="contact-section container section" id="contact" tabIndex="-1" aria-labelledby="contact-title">
            <div className="contact-panel">
                <div><p className="eyebrow">03 / Let’s talk</p><h2 id="contact-title">Good things start<br /><em>with a conversation.</em></h2><p>Have a project, a role, or an interesting problem?<br />I’d love to hear about it.</p></div>
                <div className="contact-actions">
                    <a className="button button-light" href="mailto:contact@andrewkasper.com">Say hello <span aria-hidden="true">↗</span></a>
                    <a className="contact-email" href="mailto:contact@andrewkasper.com">contact@andrewkasper.com</a>
                    <a className="contact-linkedin" href="https://www.linkedin.com/in/andrewkasper/" target="_blank" rel="noreferrer">Find me on LinkedIn <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
                </div>
            </div>
        </section>
    );
}

export default ContactMe;
